








































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import LoadingContent from '@/components/LoadingContent.vue';
import NoImage from '@/components/NoImage.vue';
import { SectionData, KnifeData, KnifeState } from './GalleryModels';
import { getMultipleAttempts } from './Utils';

@Component({
  components: {
    LoadingContent,
    NoImage,
  },
})
export default class GallerySection extends Vue {

  @Prop() private section!: SectionData;
  /**
   * Is the section opened.
   */
  @Prop({ type: Boolean, default: false }) private opened!: boolean;
  /**
   * Photos height used in cards.
   */
  @Prop({ type: [Number, String], default: 16/9 }) private photosAspectRatio!: string|number;

  /**
   * List of knives linked with this section.
   */
  private knives: KnifeData[] = [];

  private isGettingKnives = false;

  private getKnivesError = false;

  /**
   * Get pre description knife content.
   * It is returning the availability and the price.
   */
  getPreDescription(knife: KnifeData): string {
    let text = "";
    let css = "subtitle-1";
    if (knife.state == KnifeState.Available) {
      text = (knife.price !== null && knife.price !== undefined) ?
        `${knife.price / 100}€` : this.$t('gallery.available').toString();
      css += " green--text";
    } else if (knife.state == KnifeState.Unavailable) {
      text = this.$t('gallery.unavailable').toString();
      css += " red--text";
    }
    return (text != "") ? `<span class="${css}">${text}</span> - ` : "";
  }

  @Watch('opened', { immediate: true })
  private update() {
    if (this.opened && this.knives.length == 0) {
      this.getKnives();
    }
  }

  private getKnives() {
    this.knives = [];
    this.isGettingKnives = true;
    this.getKnivesError = false;
    getMultipleAttempts(this.$axios, process.env.VUE_APP_KNIVES_API,
        { 'section': this.section.id, photos: true })
      .then((response) => {
        this.isGettingKnives = false;
        this.knives = response.data;
      }).catch((/* reason */) => {
        this.isGettingKnives = false;
        this.getKnivesError = true;
      });
  }

  private emitSelectKnife(knife: KnifeData) {
    this.$emit('select-knife', knife);
  }
}
